<pagination-template #p="paginationApi"
                     [id]="config.id"
                     (pageChange)="config.currentPage = $event; resetActions(config.id)">

  <div *ngIf="config.totalItems>1" class="pagination ngx-pagination">
    <div class="page-item">
      <button role="button"
              [disabled]="currentPage<=1"
              (click)="pageOne()"
              class="btn btn-outline-info">
        <i class="icon-control-start"></i>
      </button>
    </div>

    <div class="page-item">
      <button role="button"
              [disabled]="currentPage<=1"
              (click)="previousPage()"
              class="btn btn-outline-info">
        <i class="icon-arrow-left"></i>
      </button>
   </div>

    <div class="page-item">
      <input
        required #paginationField type="text" class="form-control"
        (input)="onPageChanged($event.target.value);resizeInput($event.target.value, paginationField);" [value]="currentPage">
    </div>

    <div class="page-item">
      <button role="button"
              [disabled]="currentPage>=config.totalItems"
              class="btn btn-outline-info"
              (click)="nextPage()">
        <i class="icon-arrow-right"></i>
      </button>
    </div>
  </div>

</pagination-template>
